const tooltipDirective = (app: {
  directive: (
    arg0: string,
    arg1: {
      mounted(el: any, binding: any): void;
      updated(el: any, binding: any): void;
    }
  ) => void;
}) => {
  app.directive("tooltip", {
    mounted(el: any, binding: any) {
      init(el, binding);
    },
    updated(el: any, binding: any) {
      init(el, binding);
    },
  });
};

function init(el: HTMLElement, binding: { arg: string; value: string }) {
  const position = binding.arg || "top";
  const tooltipText = binding.value || "Tooltip text";
  el.setAttribute("position", position);
  el.setAttribute("tooltip", tooltipText);

  // Add the event listener for hiding the tooltip on click
  el.addEventListener("click", () => {
    setTimeout(() => {
      el.setAttribute("tooltip", "");
    }, 100); // Delay to allow click event to register before hiding tooltip
  });

  // Add event listener for showing the tooltip on hover
  el.addEventListener("mouseenter", () => {
    el.setAttribute("tooltip", tooltipText);
  });

  // Optional: Remove the event listener when the directive is unbound
  el.addEventListener("mouseleave", () => {
    el.setAttribute("tooltip", "");
  });
}

export default tooltipDirective;
